import {useState} from 'react';
import * as S from './RatePlanInclusionUI.styles';
import {PrimaryLink} from '../../../CommonStyleUtils/dwebCommon.styles';
import HermesIconSelector from '../../../../../shared/components/HermesIconSelector';

const RatePlanInclusionUI = ({ratePlanInclusionData = [], isMultiRoom = false}) => {
  const getAdditionalTextListItems = text => {
    return (
      <li>
        <S.BulletPointOuter>
          <S.BulletPoint />
        </S.BulletPointOuter>
        <S.BulletTextOuter>
          <S.BulletTextSpan isMultiRoom={isMultiRoom}>{text}</S.BulletTextSpan>
        </S.BulletTextOuter>
      </li>
    );
  };

  if (ratePlanInclusionData?.[0]?.templateType != 2) return;

  return (
    <S.SuperDealDetailWrapper bgColor={ratePlanInclusionData[0]?.overallBgColour}>
      <S.SuperDealPersuationWrapper
        textColor={ratePlanInclusionData[0]?.colourCodeData?.textColour}
        bgColor={ratePlanInclusionData[0]?.colourCodeData?.bgColour}
        borderColor={ratePlanInclusionData[0]?.colourCodeData?.borderColour}
        isMultiRoom={isMultiRoom}
      >
        <HermesIconSelector
          name={ratePlanInclusionData[0]?.iconTagName}
          styleProps={{
            height: '1.2rem',
            width: '1.2rem',
            fill: ratePlanInclusionData[0]?.colourCodeData?.textColour,
            margin: '0 0.4rem 0 0',
          }}
        />
        <div>{ratePlanInclusionData[0]?.persuasionText}</div>
      </S.SuperDealPersuationWrapper>

      {ratePlanInclusionData?.length > 1 ? (
        <S.OptionList>
          {getAdditionalTextListItems(ratePlanInclusionData?.[1]?.persuasionText)}
        </S.OptionList>
      ) : null}
    </S.SuperDealDetailWrapper>
  );
};

export default RatePlanInclusionUI;
